import { getDefaultStore } from 'jotai'

export const STORE = getDefaultStore()
